import COMMON_TYPES from '../../../actions/types';
import * as analytics from '../../../analytics';

import { buyCommunication } from '../../../api/communication';

const loadingPost = () => ({ type: COMMON_TYPES.formPostWatingResponse });

export const create = params => {
  return dispatch => {
    dispatch(loadingPost());

    buyCommunication(params.formParams)
      .then(({ data }) => {
        dispatch(loadingPost());
        dispatch({
          type: COMMON_TYPES.formPostResultSuccess,
          payload: data
        })
      })
      .catch(responseFail => {
        dispatch(loadingPost());
        dispatch({
          type: COMMON_TYPES.formPostResultError,
          payload: responseFail.response.data
        });
      })
  }
}

export const toggleBuyLayer = params => {
  if(params && params.id) {
    //ga
    analytics.registerEvent({
      category: analytics.categories.customerArea,
      action: analytics.actions.customerAreaBuyCredit,
    });

    return [
      { type: COMMON_TYPES.toggleLayer, payload: 'buyCommunicationBalance' }
    ]
  }

  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.formClearValues },
  ];
};
